/** Stable slug for heading anchor ids (TOC scroll spy). */
export function slugifyHeadingId(text: string): string {
	const base = text
		.toLowerCase()
		.trim()
		.replace(/[^\w\s-]/g, "")
		.replace(/\s+/g, "-")
		.replace(/-+/g, "-")
		.replace(/^-+|-+$/g, "");
	return base || "section";
}

/** Ensure unique id among siblings already assigned in this pass. */
export function uniqueHeadingId(base: string, used: Set<string>): string {
	let candidate = base;
	let n = 2;
	while (used.has(candidate)) {
		candidate = `${base}-${n}`;
		n += 1;
	}
	used.add(candidate);
	return candidate;
}

/** Stable anchor id shared by AI label generation, runtime render, and canvas. */
export function resolveHeadingAnchorId(options: {
	domId?: string | null;
	text: string;
	used: Set<string>;
}): string {
	const domId = options.domId?.trim();
	if (domId) {
		return uniqueHeadingId(domId, options.used);
	}
	return uniqueHeadingId(slugifyHeadingId(options.text), options.used);
}

/** Strip HTML tags for slug source when heading uses `html` mode. */
export function plainTextFromHeadingHtml(html: string): string {
	return html
		.replace(/<[^>]+>/g, " ")
		.replace(/\s+/g, " ")
		.trim();
}
